import React from "react";
import About from "../../components/about/About";
import Blog from "../../components/blog/Blog";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import Ingredients from "../../components/ingredient/Ingredients";
import SlideShow from "../../components/slideshow/SlideShow";

const Main = () => {
  return (
    <div>
      <Header />
      <SlideShow />
      {/* <Zoom> */}
      <About />
      {/* </Zoom> */}
      <Ingredients />
      <Blog />
      <Footer />
    </div>
  );
};

export default Main;
